var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18063_23681)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 3.33333C10.9206 3.33333 11.6668 2.58714 11.6668 1.66667C11.6668 0.746192 10.9206 0 10.0002 0C9.07969 0 8.3335 0.746192 8.3335 1.66667C8.3335 2.58714 9.07969 3.33333 10.0002 3.33333Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8924 5.69084C16.7669 5.69084 17.4757 4.98195 17.4757 4.1075C17.4757 3.23305 16.7669 2.52417 15.8924 2.52417C15.018 2.52417 14.3091 3.23305 14.3091 4.1075C14.3091 4.98195 15.018 5.69084 15.8924 5.69084Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3335 11.5C19.1619 11.5 19.8335 10.8284 19.8335 10C19.8335 9.17157 19.1619 8.5 18.3335 8.5C17.5051 8.5 16.8335 9.17157 16.8335 10C16.8335 10.8284 17.5051 11.5 18.3335 11.5Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8927 17.3092C16.6751 17.3092 17.3094 16.6749 17.3094 15.8925C17.3094 15.1101 16.6751 14.4758 15.8927 14.4758C15.1103 14.4758 14.4761 15.1101 14.4761 15.8925C14.4761 16.6749 15.1103 17.3092 15.8927 17.3092Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 19.6667C10.7362 19.6667 11.3332 19.0697 11.3332 18.3333C11.3332 17.597 10.7362 17 9.99984 17C9.26346 17 8.6665 17.597 8.6665 18.3333C8.6665 19.0697 9.26346 19.6667 9.99984 19.6667Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10742 17.1426C4.79778 17.1426 5.35742 16.5829 5.35742 15.8926C5.35742 15.2022 4.79778 14.6426 4.10742 14.6426C3.41707 14.6426 2.85742 15.2022 2.85742 15.8926C2.85742 16.5829 3.41707 17.1426 4.10742 17.1426Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 11.1666C2.311 11.1666 2.83333 10.6443 2.83333 9.99992C2.83333 9.35559 2.311 8.83325 1.66667 8.83325C1.02233 8.83325 0.5 9.35559 0.5 9.99992C0.5 10.6443 1.02233 11.1666 1.66667 11.1666Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10726 5.19084C4.70557 5.19084 5.19059 4.70581 5.19059 4.1075C5.19059 3.50919 4.70557 3.02417 4.10726 3.02417C3.50895 3.02417 3.02393 3.50919 3.02393 4.1075C3.02393 4.70581 3.50895 5.19084 4.10726 5.19084Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18063_23681"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.cb112c62731e89e40446e31546b5875f.svg";
export { ForwardRef as ReactComponent };